import { _ as _extends } from '../../_rollupPluginBabelHelpers-1b8c042f.js';
import { forwardRef, useContext } from 'react';
import { themed } from '@indeed/ifl-css';
import transition from '../../utils/transition.js';
import 'focus-visible';
import { jsx } from '@emotion/react';
import { LinkProviderContext } from '../LinkProvider/LinkProvider.js';
import { IconWrapper } from '../IconWrapper/IconWrapper.js';

const TEXT_LINK_DEFAULT_TAG = "a";
const variants = {
  standard: {
    color: "foreground.action.primary",
    ":visited": {
      color: "foreground.action.primary"
    },
    ":hover": {
      color: "foreground.action.primary.hover"
    },
    ":active": {
      color: "foreground.action.primary.active"
    },
    ":focus": {
      color: "foreground.action.primary"
    }
  },
  neutral: {
    color: "foreground.action",
    ":visited": {
      color: "foreground.action"
    },
    ":hover": {
      color: "foreground.action.hover"
    },
    ":active": {
      color: "foreground.action.active"
    },
    ":focus": {
      color: "foreground.action"
    }
  },
  inverse: {
    color: "foreground.action.inverse",
    ":visited": {
      color: "foreground.action.inverse"
    },
    ":hover": {
      color: "foreground.action.inverse.hover"
    },
    ":active": {
      color: "foreground.action.inverse.active"
    },
    ":focus": {
      color: "foreground.action.inverse"
    }
  }
};
const inlineStyles = {
  standard: {
    ":hover": {
      color: "foreground.action.primary.hover",
      bg: "background.action.hover"
    },
    ":active": {
      color: "foreground.action.primary.active",
      bg: "background.action.active"
    }
  },
  neutral: {
    ":hover": {
      color: "foreground.action.hover",
      bg: "background.action.weak.hover"
    },
    ":active": {
      color: "foreground.action.active",
      bg: "background.action.weak.active"
    }
  },
  inverse: {
    ":hover": {
      color: "foreground.action.inverse.hover",
      bg: "background.action.inverse.hover"
    },
    ":active": {
      color: "foreground.action.inverse",
      bg: "background.action.inverse.active"
    }
  }
};

const baseStyles = _ref => {
  let {
    variant = "standard",
    inline = false
  } = _ref;
  return {
    fontFamily: "default",
    borderBottom: "1px solid",
    textDecoration: "none",
    cursor: "pointer",
    ...variants[variant],
    ...(inline && inlineStyles[variant]),
    transition: _ref2 => {
      let {
        transitions
      } = _ref2;
      return transition(transitions.default, "border-color", "background-color", "opacity", "border-bottom-color", "border-bottom-style", "border-bottom-width", "border-radius", "box-shadow", "color");
    },
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none"
    },
    ":focus": {
      outline: "none",
      boxShadow: "focus"
    },
    ":focus:active:not([data-focus-visible-added]), :focus:not([data-focus-visible-added])": {
      boxShadow: "none",
      borderBottom: "1px solid"
    }
  };
};

const StyledTextLink = /*#__PURE__*/themed(TEXT_LINK_DEFAULT_TAG, process.env.NODE_ENV === "production" ? {
  styleProps: ["variant", "inline"],
  shouldForwardProp: prop => prop !== "variant" && prop !== "inline",
  target: "e19afand0"
} : {
  styleProps: ["variant", "inline"],
  shouldForwardProp: prop => prop !== "variant" && prop !== "inline",
  target: "e19afand0",
  label: "StyledTextLink"
})(baseStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
/**
 * @see https://experience.indeed.design/components/ids/text-link
 */

const TextLink = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
    children,
    iconAfter,
    ...props
  } = _ref3;
  const {
    onClick: onClickFromContext
  } = useContext(LinkProviderContext);
  return jsx(StyledTextLink, _extends({
    ref: ref,
    onClick: onClickFromContext
  }, props), children, iconAfter && jsx(IconWrapper, {
    sx: {
      display: "inline-flex",
      blockSize: "1em",
      inlineSize: "1em",
      marginBlockEnd: 1,
      marginInlineStart: 1,
      verticalAlign: "middle"
    }
  }, iconAfter));
});
const TEXT_LINK_VARIANTS = Object.keys(variants);
TextLink.displayName = "TextLink";

export { StyledTextLink, TEXT_LINK_DEFAULT_TAG, TEXT_LINK_VARIANTS, TextLink, inlineStyles };
